import React from 'react';
import { bool, node, string } from 'prop-types';
import clsx from 'clsx';

import Badge from '@material-ui/core/Badge';
import Tab from '@material-ui/core/Tab';

import defaultClasses from './TabNavItem.module.css';

const TabNavItem = ({
    badgeContent,
    children,
    contentId,
    error,
    ...props
}) => {
    let label = children;
    if (error) {
        label = (
            <Badge
                badgeContent={badgeContent}
                classes={{
                    badge: defaultClasses.badge
                }}
                color="secondary"
            >
                {children}
            </Badge>
        );
    }
    return (
        <Tab
            aria-controls={contentId}
            classes={{
                root: clsx({
                    [defaultClasses.error]: error
                }),
                wrapper: defaultClasses.label
            }}
            id={`tab-${contentId}`}
            label={label}
            {...props}
        />
    );
};

TabNavItem.defaultProps = {
    badgeContent: '!'
};

TabNavItem.propTypes = {
    badgeContent: node,
    children:     node,
    contentId:    string,
    error:        bool
};

export default TabNavItem;
